var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fi:download"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.20033 8.16699C2.49488 8.16699 2.73366 8.40577 2.73366 8.70033V10.8337C2.73366 10.9751 2.78985 11.1108 2.88987 11.2108C2.98989 11.3108 3.12554 11.367 3.26699 11.367H10.7337C10.8751 11.367 11.0108 11.3108 11.1108 11.2108C11.2108 11.1108 11.267 10.9751 11.267 10.8337V8.70033C11.267 8.40577 11.5058 8.16699 11.8003 8.16699C12.0949 8.16699 12.3337 8.40577 12.3337 8.70033V10.8337C12.3337 11.258 12.1651 11.665 11.865 11.965C11.565 12.2651 11.158 12.4337 10.7337 12.4337H3.26699C2.84265 12.4337 2.43568 12.2651 2.13562 11.965C1.83556 11.665 1.66699 11.258 1.66699 10.8337V8.70033C1.66699 8.40577 1.90577 8.16699 2.20033 8.16699Z",
    fill: "#71839B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.95601 5.6567C4.16429 5.44842 4.50198 5.44842 4.71026 5.6567L6.9998 7.94624L9.28935 5.6567C9.49763 5.44842 9.83532 5.44842 10.0436 5.6567C10.2519 5.86498 10.2519 6.20267 10.0436 6.41095L7.37693 9.07761C7.16865 9.28589 6.83096 9.28589 6.62268 9.07761L3.95601 6.41095C3.74773 6.20267 3.74773 5.86498 3.95601 5.6567Z",
    fill: "#71839B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.00013 1.76709C7.29468 1.76709 7.53346 2.00587 7.53346 2.30042V8.70042C7.53346 8.99498 7.29468 9.23376 7.00013 9.23376C6.70558 9.23376 6.4668 8.99498 6.4668 8.70042V2.30042C6.4668 2.00587 6.70558 1.76709 7.00013 1.76709Z",
    fill: "#71839B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.0aaee5840288a4d33ec6e72ce0f0306f.svg";
export { ForwardRef as ReactComponent };